import { Injectable } from '@angular/core';
import { SequenceSearchResultDetailsResponse } from '@api/sequence/responses/sequence-search-result-details.response';
import { SequenceSearchResult } from '@features/sequence/models/sequence-search-result';

@Injectable({
  providedIn: 'root',
})
export class SequenceSearchResultDetailsConverter {
  fromResponse(
    response: SequenceSearchResultDetailsResponse
  ): SequenceSearchResult {
    const {
      queryLength,
      queryTitle,
      queryId,
      program,
      version,
      reference,
      database,
    } = response.data;

    return new SequenceSearchResult(
      response.id,
      response.rid,
      response.createdAt,
      program,
      version,
      queryId,
      queryLength,
      queryTitle,
      reference,
      database
    );
  }
}
